import { useRouter } from 'next/router'

import { beta1Links, betaLinks, developmentLinks, productionLinks, qaLinks, stageLinks } from '@local/utils'

import Clickable from '@web/components/Clickable'
import Alert from '@web/components/Modal/Alert'
import { createModal } from '@web/components/Modal/GlobalModal/globalModal.helper'
import { openToast } from '@web/components/Toast/GlobalToastPortal'
import { useGlobalStaticStateContext } from '@web/hooks/useGlobalStaticState'
import useMe from '@web/hooks/useMe'
import useReactiveSessionStorage from '@web/hooks/useReactiveSessionStorage'
import { PHASE } from '@web/libs/constants'
import { neloLogger } from '@web/libs/utils'

const PhaseLabel = () => {
  const { userAgent } = useGlobalStaticStateContext()
  const [showDetail, setShowDetail] = useReactiveSessionStorage('PhaseLabelDetail', false)
  const { me } = useMe()
  const router = useRouter()

  if (PHASE === 'production') return null

  const handleCopy = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    navigator.clipboard.writeText(`PHASE: ${PHASE}\nUSER_AGENT: ${userAgent}\nidno: ${me?.idno}\nuserId: ${me?.id}`)
    openToast({
      title: '클립보드에 복사되었습니다.',
    })
  }

  const handleLogging = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    neloLogger('info', 'SNAP SHOT ENVIRONMENT', {
      phase: PHASE,
      userAgent,
      idno: me?.idno,
      userId: me?.id,
    })
    openToast({
      title: '넬로에 현재 환경정보가 기록되었습니다.',
    })
  }

  const handleChange = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()

    const PHASE_LIST: (typeof PHASE)[] = ['development', 'qa', 'beta', 'beta1', 'stage', 'production']

    const modal = createModal(Alert, {
      title: 'PHASE 변경',
      message: (
        <>
          {PHASE_LIST.map(phase => (
            <Clickable
              key={phase}
              style={{ color: PHASE === phase ? 'blue' : 'black', display: 'block' }}
              onClick={() => changePhase(phase)}
            >
              {phase}
            </Clickable>
          ))}
        </>
      ),
      label: { confirm: '확인' },
    })

    modal.openModal()

    const changePhase = (phase: typeof PHASE) => {
      let origin = ''

      if (phase === 'development') {
        origin = developmentLinks.ORIGIN
      } else if (phase === 'qa') {
        origin = qaLinks.ORIGIN
      } else if (phase === 'beta') {
        origin = betaLinks.ORIGIN
      } else if (phase === 'beta1') {
        origin = beta1Links.ORIGIN
      } else if (phase === 'stage') {
        origin = stageLinks.ORIGIN
      } else if (phase === 'production') {
        origin = productionLinks.ORIGIN
      }

      const currentPathname = location.pathname
      const currentSearch = location.search

      const url = origin + currentPathname + currentSearch

      modal.closeModal()
      router.replace(url)
    }
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        cursor: 'pointer',
        color: 'white',
        padding: '2px',
        fontSize: '12px',
      }}
      onClick={() => setShowDetail(!showDetail)}
    >
      {PHASE}
      {showDetail && (
        <>
          <button style={{ marginLeft: '4px' }} onClick={handleChange}>
            🔁
          </button>
          <button style={{ marginLeft: '4px' }} onClick={handleCopy}>
            📋
          </button>
          <button style={{ marginLeft: '4px' }} onClick={handleLogging}>
            🔍
          </button>
          <div>UserAgent: {userAgent}</div>
          {me && (
            <>
              <div>idno: {me.idno}</div>
              <div>userId: {me.id}</div>
            </>
          )}
        </>
      )}
    </div>
  )
}

export default PhaseLabel
